import React from 'react';
import './index.scss';

interface IUploadPanelProps {
    type: 'image' | 'video';
    hasMultiple: boolean;
    removeDialog: () => void;
    imageUploadFun: (imgFile: FileList | null) => void;
    videoUploadFun: (videoFile: FileList | null) => void;
}

const UploadPanel = (props: IUploadPanelProps) => {
    const imageUploadFun = (e: React.ChangeEvent<HTMLInputElement>) => {
        props.imageUploadFun(e.target.files);
        props.removeDialog();
    };
    const videoUploadFun = (e: React.ChangeEvent<HTMLInputElement>) => {
        props.videoUploadFun(e.target.files);
        props.removeDialog();
    };

    if (props.type === 'video') {
        return (
            <div className="upload-panel-wrap">
                <div className="panelBox">
                    <i
                        className="w-e-icon-close w-e-panel-close"
                        onClick={() => props.removeDialog()}></i>
                    <ul className="w-e-panel-tab-title">
                        <li className="w-e-item w-e-active">上传视频</li>
                    </ul>
                    <div className="w-e-panel-tab-content">
                        <div className="w-e-up-video-container">
                            <div id="videoUploadBox20766827220150308">
                                <i className="w-e-icon-upload2"></i>
                                <div
                                    id="up-trigger43449208506072856"
                                    className="selectBtn">
                                    <p>选择视频</p>
                                    <input
                                        type="file"
                                        id="up-file9038717715317537"
                                        accept="audio/mp4, video/mp4,video/mov"
                                        onChange={(
                                            e: React.ChangeEvent<
                                                HTMLInputElement
                                            >
                                        ) => videoUploadFun(e)}
                                    />
                                </div>
                                <p className="slectBtnDesc">
                                    为了获得更高的推荐量和点击量，
                                    <br />
                                    建议上传720p（1280x720）或更高分辨率的视频，大小不超过2G
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
                <div
                    className="bigPanelcontainerShade"
                    onClick={() => props.removeDialog()}></div>
            </div>
        );
    } else {
        return (
            <div className="upload-panel-wrap">
                <div className="panelBox">
                    <i
                        className="w-e-icon-close w-e-panel-close"
                        onClick={() => props.removeDialog()}></i>
                    <ul className="w-e-panel-tab-title">
                        <li className="w-e-item w-e-active">上传图片</li>
                    </ul>
                    <div className="w-e-panel-tab-content">
                        <div className="w-e-up-video-container">
                            <div id="videoUploadBox20766827220150308">
                                <i className="w-e-icon-upload2"></i>
                                <div
                                    id="up-trigger43449208506072856"
                                    className="selectBtn">
                                    <p>选择图片</p>
                                    <input
                                        type="file"
                                        id="up-file9038717715317537"
                                        accept="image/jpg,image/jpeg,image/png,image/gif"
                                        multiple={props.hasMultiple}
                                        onChange={(
                                            e: React.ChangeEvent<
                                                HTMLInputElement
                                            >
                                        ) => imageUploadFun(e)}
                                    />
                                </div>
                                <p className="slectBtnDesc">
                                    支持图片格式JPG/GIF/PNG，最大不能超过5M
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
                <div
                    className="bigPanelcontainerShade"
                    onClick={() => props.removeDialog()}></div>
            </div>
        );
    }
};

export default UploadPanel;
